import _get from 'lodash.get';

import { Nullable } from '../../../types';

export const APPLE_PAY_CONTAINER_ID = 'applepay-container';

export type ApplePayErrorType = 'initialization' | 'payment';

export function extractApplePayToken(state: unknown): Nullable<string> {
  const token = _get(state, 'data.paymentMethod.applePayToken', null);
  return typeof token === 'string' ? token : null;
}
